// IMPORTANT
// This is an indicator that user has to go though tax withholdings setup flow
// It's not an indicator whether tax withholdings activated or not

import { IMember } from "@wingspanhq/users/dist/lib/interfaces";
import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";

export const selectorIsTaxWithholdingsSetupComplete = (
  member?: IMember,
  internalAccounts?: bankingApiSpec.InternalAccount[]
) => {
  if (!member) {
    return false;
  }

  // User has to have tax rate set
  if (!member.profile.withholdings?.tax?.rate) {
    return false;
  }

  // User has to have tax withholding account
  // It's doesn't have to be active in terms of setup completion, but it has to exist
  const hasTaxWithholdingAccount = internalAccounts?.some(
    internalAccount => internalAccount.type === "TaxWithholding"
  );

  if (!hasTaxWithholdingAccount) {
    return false;
  }

  return true;
};
